/**
 * Created with Mei Zhiwei on 2017-10-23 18:16:55.
 * Description: sso
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-08-29 17:57:12
 */
import cookie from '@/lib/cookie.js';
import { host } from '@/config';

export default {
  login: function () {
    let goLogin = cookie.getCookie('GoLoginMeta');
    if (!goLogin) {
      // 防止一个页面的多个请求，多个重定向
      cookie.setCookie('GoLoginMeta', window.location.href, 10);
      window.location.href = host.HOME;
    }
  },
  bind: function () {
    let goLogin = cookie.getCookie('GoBindMeta');
    if (!goLogin) {
      // 防止一个页面的多个请求，多个重定向
      cookie.setCookie('GoBindMeta', window.location.href, 10);
      window.location.href = host.BIND;
    }
  }
};



// WEBPACK FOOTER //
// ./src/lib/auth.js